export const MENUS = {
  UNSELECTED: "unselected",
  HOME: "home",
  SETTINGS_PERSONAL: "settings_personal",
  SETTINGS_WORKSPACES: "settings_workspaces",
};
